import { IncomingMessage } from "./incoming-message.js";
/**
 * Incoming response message.
 * @public
 */
export class IncomingResponseMessage extends IncomingMessage {
    constructor() {
        super();
    }
}
